/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SudoModifyUserQueryVariables = {};
export type SudoModifyUserQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"SudoModifyUser_viewer">;
    };
};
export type SudoModifyUserQuery = {
    readonly response: SudoModifyUserQueryResponse;
    readonly variables: SudoModifyUserQueryVariables;
};



/*
query SudoModifyUserQuery {
  viewer {
    ...SudoModifyUser_viewer
    id
  }
}

fragment SudoModifyUser_viewer on Viewer {
  id
  sudo {
    modifyUser {
      user {
        id
        givenName
        familyName
        emails
        status
        externalImageUrl
        flowStates(first: 1000000) {
          edges {
            node {
              id
              flowKey
              current {
                id
                state
                percentComplete
                errorMessage
              }
              pending {
                id
                state
                percentComplete
                errorMessage
              }
            }
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              id
              name
              flowStates(first: 1000000) {
                edges {
                  node {
                    id
                    flowKey
                    current {
                      id
                      state
                      percentComplete
                      errorMessage
                    }
                    pending {
                      id
                      state
                      percentComplete
                      errorMessage
                    }
                  }
                }
              }
            }
          }
        }
      }
      userTeams {
        __typename
        ... on TeamList {
          list {
            teamId
            teamName
            id
          }
        }
      }
      subscriptions {
        __typename
        ... on PaymentSubscriptionList {
          list {
            id
            type
            subjectUrn {
              value
              type
              id
            }
          }
        }
      }
      orgAccountingPeriod {
        __typename
        ... on OrgAccountingPeriod {
          periodRange {
            minDate
            maxDate
          }
          quotaMax
          quotaUsed
          enforcementState
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
      featureStatesJson
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v2 = [
        (v0 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ], v3 = {
        "alias": null,
        "args": (v1 /*: any*/),
        "concreteType": "FlowStateConnection",
        "kind": "LinkedField",
        "name": "flowStates",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flowKey",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "current",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "pending",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "flowStates(first:1000000)"
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "SudoModifyUserQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SudoModifyUser_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "SudoModifyUserQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sudo",
                            "kind": "LinkedField",
                            "name": "sudo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserAndExtendedInfo",
                                    "kind": "LinkedField",
                                    "name": "modifyUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "givenName",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "familyName",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "emails",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "status",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "externalImageUrl",
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v1 /*: any*/),
                                                    "concreteType": "OrgConnection",
                                                    "kind": "LinkedField",
                                                    "name": "orgs",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "OrgEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Org",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v0 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "name",
                                                                            "storageKey": null
                                                                        },
                                                                        (v3 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "orgs(first:1000000)"
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "userTeams",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Team",
                                                            "kind": "LinkedField",
                                                            "name": "list",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "teamId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "teamName",
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "TeamList",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "subscriptions",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PaymentSubscription",
                                                            "kind": "LinkedField",
                                                            "name": "list",
                                                            "plural": true,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                (v5 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Urn",
                                                                    "kind": "LinkedField",
                                                                    "name": "subjectUrn",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "value",
                                                                            "storageKey": null
                                                                        },
                                                                        (v5 /*: any*/),
                                                                        (v0 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "PaymentSubscriptionList",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "orgAccountingPeriod",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "DateRange",
                                                            "kind": "LinkedField",
                                                            "name": "periodRange",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "minDate",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "maxDate",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "quotaMax",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "quotaUsed",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "enforcementState",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "OrgAccountingPeriod",
                                                    "abstractKey": null
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "statusCode",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "message",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "GraphEntityError",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "featureStatesJson",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v0 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c7e87bcd016f6756b005ce77d8fdc6c2",
            "id": null,
            "metadata": {},
            "name": "SudoModifyUserQuery",
            "operationKind": "query",
            "text": "query SudoModifyUserQuery {\n  viewer {\n    ...SudoModifyUser_viewer\n    id\n  }\n}\n\nfragment SudoModifyUser_viewer on Viewer {\n  id\n  sudo {\n    modifyUser {\n      user {\n        id\n        givenName\n        familyName\n        emails\n        status\n        externalImageUrl\n        flowStates(first: 1000000) {\n          edges {\n            node {\n              id\n              flowKey\n              current {\n                id\n                state\n                percentComplete\n                errorMessage\n              }\n              pending {\n                id\n                state\n                percentComplete\n                errorMessage\n              }\n            }\n          }\n        }\n        orgs(first: 1000000) {\n          edges {\n            node {\n              id\n              name\n              flowStates(first: 1000000) {\n                edges {\n                  node {\n                    id\n                    flowKey\n                    current {\n                      id\n                      state\n                      percentComplete\n                      errorMessage\n                    }\n                    pending {\n                      id\n                      state\n                      percentComplete\n                      errorMessage\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      userTeams {\n        __typename\n        ... on TeamList {\n          list {\n            teamId\n            teamName\n            id\n          }\n        }\n      }\n      subscriptions {\n        __typename\n        ... on PaymentSubscriptionList {\n          list {\n            id\n            type\n            subjectUrn {\n              value\n              type\n              id\n            }\n          }\n        }\n      }\n      orgAccountingPeriod {\n        __typename\n        ... on OrgAccountingPeriod {\n          periodRange {\n            minDate\n            maxDate\n          }\n          quotaMax\n          quotaUsed\n          enforcementState\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n      }\n      featureStatesJson\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'd446497d8d72d9f360d13f818b8b600b';
export default node;
